var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 265,
    viewBox: "0 0 496 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_904_2490)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M495.897 232.454C490.86 182.184 478.268 57.3417 475.509 39.1097C472.049 16.1798 443.66 21.2338 443.66 21.2338C443.66 21.2338 270.674 26.695 195.412 28.4927C183.111 28.781 175.744 28.374 172.283 29.7138C167.914 31.0706 164.71 33.6825 163.203 35.0902C156.281 40.8396 157.515 60.1231 157.515 60.1231C157.515 60.1231 154.876 183.507 153.883 239.543C155.236 248.583 160.958 253.314 160.958 253.314H477.154C482.465 253.314 487.553 251.042 491.117 247.056C494.68 243.071 496.411 237.779 495.88 232.454H495.897ZM204.098 64.4988C199.969 64.4988 196.611 61.1746 196.611 57.0873C196.611 52.9999 199.969 49.6758 204.098 49.6758C208.227 49.6758 211.585 52.9999 211.585 57.0873C211.585 61.1746 208.227 64.4988 204.098 64.4988ZM265.449 63.9222C261.32 63.9222 257.962 60.598 257.962 56.5106C257.962 52.4233 261.32 49.0991 265.449 49.0991C269.578 49.0991 272.936 52.4233 272.936 56.5106C272.936 60.598 269.578 63.9222 265.449 63.9222ZM327.365 61.9209C323.237 61.9209 319.879 58.5967 319.879 54.5094C319.879 50.422 323.237 47.0978 327.365 47.0978C331.494 47.0978 334.852 50.422 334.852 54.5094C334.852 58.5967 331.494 61.9209 327.365 61.9209ZM388.717 59.0716C384.588 59.0716 381.23 55.7474 381.23 51.6601C381.23 47.5727 384.588 44.2486 388.717 44.2486C392.845 44.2486 396.203 47.5727 396.203 51.6601C396.203 55.7474 392.845 59.0716 388.717 59.0716Z",
    fill: "url(#paint0_linear_904_2490)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M453.17 20.9115L176.927 29.0184C166.425 29.3237 158.013 37.7189 157.79 48.1154L153.747 236.524C153.49 248.752 163.29 258.894 175.659 259.149L453.376 264.983C461.102 265.152 467.458 259.013 467.476 251.364L468.144 35.3445C468.161 27.2037 461.376 20.6741 453.17 20.9115ZM204.099 64.4987C199.97 64.4987 196.612 61.1746 196.612 57.0872C196.612 52.9999 199.97 49.6757 204.099 49.6757C208.228 49.6757 211.586 52.9999 211.586 57.0872C211.586 61.1746 208.228 64.4987 204.099 64.4987ZM265.45 63.9221C261.321 63.9221 257.963 60.5979 257.963 56.5106C257.963 52.4232 261.321 49.0991 265.45 49.0991C269.579 49.0991 272.937 52.4232 272.937 56.5106C272.937 60.5979 269.579 63.9221 265.45 63.9221ZM327.367 61.9208C323.238 61.9208 319.88 58.5967 319.88 54.5093C319.88 50.4219 323.238 47.0978 327.367 47.0978C331.496 47.0978 334.854 50.4219 334.854 54.5093C334.854 58.5967 331.496 61.9208 327.367 61.9208ZM388.718 59.0715C384.589 59.0715 381.231 55.7474 381.231 51.66C381.231 47.5727 384.589 44.2485 388.718 44.2485C392.847 44.2485 396.205 47.5727 396.205 51.66C396.205 55.7474 392.847 59.0715 388.718 59.0715Z",
    fill: "url(#paint1_linear_904_2490)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M454.728 40.28C454.591 36.5149 451.387 33.5808 447.584 33.6995L170.108 42.4678C166.733 42.5696 164.111 45.4189 164.3 48.76C168.412 122.027 155.614 210.27 151.536 235.931C150.919 239.797 153.9 243.308 157.858 243.359L449.023 247.769C451.816 247.803 454.197 245.767 454.557 243.02C460.313 197.923 455.91 71.0794 454.728 40.263V40.28ZM204.098 64.4989C199.969 64.4989 196.611 61.1747 196.611 57.0874C196.611 53 199.969 49.6758 204.098 49.6758C208.227 49.6758 211.585 53 211.585 57.0874C211.585 61.1747 208.227 64.4989 204.098 64.4989ZM265.449 63.9222C261.321 63.9222 257.963 60.5981 257.963 56.5107C257.963 52.4234 261.321 49.0992 265.449 49.0992C269.578 49.0992 272.936 52.4234 272.936 56.5107C272.936 60.5981 269.578 63.9222 265.449 63.9222ZM327.366 61.921C323.237 61.921 319.879 58.5968 319.879 54.5094C319.879 50.4221 323.237 47.0979 327.366 47.0979C331.495 47.0979 334.853 50.4221 334.853 54.5094C334.853 58.5968 331.495 61.921 327.366 61.921ZM388.717 59.0717C384.588 59.0717 381.23 55.7475 381.23 51.6602C381.23 47.5728 384.588 44.2486 388.717 44.2486C392.846 44.2486 396.204 47.5728 396.204 51.6602C396.204 55.7475 392.846 59.0717 388.717 59.0717Z",
    fill: "url(#paint2_linear_904_2490)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M450.565 45.0456C450.428 41.4162 447.361 38.5839 443.695 38.7026L176.669 47.1317C173.414 47.2335 170.895 49.964 171.084 53.1864C175.041 123.706 162.723 208.625 158.8 233.319C158.2 237.033 161.079 240.425 164.882 240.476L445.082 244.733C447.772 244.767 450.068 242.816 450.41 240.17C455.944 196.77 451.713 74.6917 450.582 45.0456H450.565ZM204.098 64.4987C199.969 64.4987 196.611 61.1746 196.611 57.0872C196.611 52.9999 199.969 49.6757 204.098 49.6757C208.227 49.6757 211.585 52.9999 211.585 57.0872C211.585 61.1746 208.227 64.4987 204.098 64.4987ZM265.449 63.9221C261.32 63.9221 257.962 60.5979 257.962 56.5106C257.962 52.4232 261.32 49.0991 265.449 49.0991C269.578 49.0991 272.936 52.4232 272.936 56.5106C272.936 60.5979 269.578 63.9221 265.449 63.9221ZM327.366 61.9208C323.237 61.9208 319.879 58.5967 319.879 54.5093C319.879 50.4219 323.237 47.0978 327.366 47.0978C331.495 47.0978 334.852 50.4219 334.852 54.5093C334.852 58.5967 331.495 61.9208 327.366 61.9208ZM388.717 59.0715C384.588 59.0715 381.23 55.7474 381.23 51.66C381.23 47.5727 384.588 44.2485 388.717 44.2485C392.846 44.2485 396.204 47.5727 396.204 51.66C396.204 55.7474 392.846 59.0715 388.717 59.0715Z",
    fill: "url(#paint3_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.993 91.94L328.582 110.986C328.513 113.886 330.877 116.278 333.807 116.295L353.526 116.396C356.405 116.396 358.752 114.141 358.82 111.308L359.248 91.2956C359.317 88.2936 356.799 85.8514 353.766 85.9871L334.012 86.852C331.237 86.9708 329.044 89.1925 328.993 91.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.035 116.125L279.755 116.244C282.633 116.244 284.98 113.988 285.049 111.156L285.409 94.1281C285.477 91.1431 282.976 88.7009 279.96 88.8196L260.224 89.5149C257.431 89.6167 255.221 91.8554 255.153 94.6029L254.81 110.817C254.742 113.717 257.106 116.108 260.035 116.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.306 200.925L258.546 200.739C255.411 200.705 252.824 203.181 252.755 206.302L252.378 223.702C252.31 226.789 254.76 229.367 257.878 229.503L276.621 230.283C279.842 230.419 282.531 227.909 282.6 224.72L282.994 206.726C283.062 203.571 280.51 200.959 277.306 200.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M245.746 223.278L246.106 206.268C246.175 203.164 243.656 200.603 240.521 200.569L221.555 200.382C218.472 200.349 215.936 202.791 215.868 205.844L215.525 222.244C215.456 225.28 217.855 227.807 220.922 227.942L239.87 228.74C243.022 228.875 245.678 226.416 245.746 223.278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M247.392 146.5L247.683 132.542C247.752 129.167 245.01 126.403 241.601 126.403L223.492 126.437C220.203 126.437 217.513 129.049 217.427 132.322L217.136 145.669C217.068 148.96 219.689 151.69 223.012 151.809L241.104 152.403C244.479 152.504 247.306 149.875 247.375 146.517L247.392 146.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M246.517 187.069L246.98 165.716C247.048 162.663 244.616 160.119 241.532 160.018L223.012 159.424C219.637 159.322 216.81 161.951 216.741 165.309L216.279 186.848C216.21 189.969 218.763 192.547 221.915 192.547H240.881C243.948 192.547 246.449 190.122 246.517 187.086V187.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M296.922 116.329L316.642 116.43C319.52 116.43 321.867 114.175 321.935 111.342L322.329 92.8051C322.398 89.8201 319.897 87.3779 316.881 87.4966L297.145 88.1919C294.352 88.2937 292.142 90.5324 292.074 93.2799L291.697 111.003C291.628 113.903 293.993 116.295 296.922 116.312V116.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.421 186.984L283.85 167.005C283.918 163.901 281.434 161.306 278.299 161.205L259.539 160.594C256.352 160.492 253.679 162.985 253.611 166.157L253.165 186.729C253.097 189.918 255.684 192.53 258.905 192.53H277.665C280.783 192.53 283.336 190.054 283.404 186.967L283.421 186.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M317.155 126.267L295.619 126.301C293.255 126.301 291.319 128.184 291.268 130.524L290.856 149.723C290.805 152.08 292.69 154.048 295.071 154.116L316.589 154.811C319.005 154.896 321.027 152.996 321.078 150.605L321.506 130.66C321.558 128.235 319.588 126.25 317.155 126.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.153 131.542L327.759 149.825C327.691 152.793 330.055 155.252 333.053 155.354L352.344 155.981C355.394 156.083 357.929 153.692 357.998 150.69L358.409 131.745C358.478 128.709 355.993 126.216 352.927 126.216L333.619 126.25C330.655 126.25 328.222 128.608 328.153 131.559V131.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.202 152.928L279.72 153.624C282.136 153.709 284.158 151.809 284.209 149.401L284.603 130.728C284.654 128.302 282.684 126.318 280.251 126.335L258.716 126.369C256.352 126.369 254.416 128.252 254.364 130.592L253.987 148.536C253.936 150.893 255.821 152.861 258.202 152.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M315.167 162.409L296.407 161.798C293.22 161.697 290.547 164.19 290.479 167.361L290.068 186.747C289.999 189.935 292.586 192.547 295.807 192.547H314.567C317.685 192.547 320.238 190.071 320.306 186.984L320.718 168.209C320.786 165.106 318.302 162.511 315.167 162.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M352.688 163.613L332.626 162.969C329.799 162.884 327.435 165.089 327.383 167.887L326.972 187.408C326.904 190.223 329.199 192.547 332.061 192.547H352.14C354.898 192.547 357.159 190.359 357.228 187.629L357.639 168.752C357.691 166.005 355.515 163.715 352.722 163.613H352.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M225.891 115.684L240.865 115.769C244.84 115.786 248.112 112.648 248.198 108.697L248.455 96.4683C248.541 92.7711 245.457 89.7691 241.722 89.9048L225.052 90.4984C221.266 90.6341 218.25 93.6699 218.182 97.4011L217.959 107.611C217.856 112.021 221.437 115.65 225.874 115.667L225.891 115.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M209.221 206.352C209.289 203.011 206.582 200.247 203.207 200.213L196.68 200.145C191.729 200.094 187.668 203.333 187.583 207.421L187.326 219.242C187.24 223.295 191.095 226.687 195.995 226.891L203.002 227.179C206.154 227.315 208.81 224.856 208.878 221.718L209.204 206.335L209.221 206.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.92 202.282L406.088 202.163C402.936 202.129 400.349 204.622 400.298 207.726L399.818 229.876C399.749 232.963 402.199 235.54 405.317 235.676L418.081 236.219C423.169 236.439 427.435 233.149 427.538 228.943L427.949 209.948C428.035 205.776 423.974 202.333 418.92 202.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M197.193 192.53H203.566C206.873 192.53 209.563 189.918 209.631 186.645L210.094 164.936C210.162 161.646 207.541 158.915 204.217 158.796L197.81 158.593C192.756 158.423 188.558 161.697 188.455 165.869L188.044 184.864C187.959 189.07 192.088 192.53 197.176 192.53H197.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M197.742 150.978L205.76 151.232C208.313 151.317 210.437 149.316 210.506 146.789L210.849 131.101C210.9 128.557 208.827 126.454 206.257 126.454H198.171C193.271 126.471 189.279 129.71 189.193 133.746L188.988 143.295C188.902 147.382 192.808 150.791 197.76 150.944L197.742 150.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M420.978 83.5449L408.112 84.0029C405.216 84.1046 402.904 86.4281 402.835 89.2944L402.372 111.173C402.304 114.192 404.754 116.685 407.803 116.702L421.047 116.77C425.981 116.804 430.007 113.564 430.093 109.494L430.487 91.1939C430.572 86.8691 426.204 83.3584 420.961 83.5449H420.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.208 201.281L295.448 201.095C292.313 201.061 289.726 203.537 289.657 206.657L289.263 225.246C289.195 228.332 291.645 230.91 294.763 231.046L313.505 231.826C316.726 231.962 319.416 229.452 319.485 226.263L319.896 207.065C319.964 203.91 317.412 201.298 314.208 201.264V201.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M420.428 126.081H407.391C404.427 126.114 401.994 128.455 401.925 131.406L401.48 152.216C401.411 155.184 403.776 157.643 406.774 157.745L419.863 158.169C424.917 158.338 429.115 155.065 429.217 150.893L429.577 133.746C429.663 129.54 425.534 126.081 420.428 126.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M419.967 165.801L406.364 165.36C403.537 165.275 401.172 167.48 401.121 170.278L400.761 187.408C400.693 190.223 402.988 192.547 405.85 192.547H419.521C424.438 192.547 428.43 189.325 428.516 185.271L428.773 173.45C428.858 169.363 424.952 165.954 420.001 165.801H419.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.235 169.091L363.841 187.425C363.773 190.24 366.069 192.564 368.93 192.564H389.009C391.767 192.564 394.029 190.376 394.097 187.645L394.474 169.973C394.525 167.225 392.35 164.936 389.557 164.834L369.495 164.19C366.668 164.105 364.304 166.31 364.253 169.108L364.235 169.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M387.962 201.994L369.202 201.807C366.05 201.773 363.463 204.249 363.412 207.37L362.966 228.332C362.898 231.419 365.348 233.997 368.466 234.133L387.209 234.913C390.429 235.049 393.119 232.539 393.188 229.35L393.65 207.794C393.719 204.622 391.166 202.011 387.962 201.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M198.787 115.531L206.634 115.582C209.135 115.582 211.191 113.615 211.242 111.139L211.568 95.8069C211.619 93.1951 209.443 91.0751 206.822 91.1769L198.513 91.4652C193.75 91.6348 189.998 94.8063 189.912 98.741L189.724 107.882C189.638 112.055 193.716 115.514 198.804 115.548L198.787 115.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M351.077 201.637L332.642 201.468C329.318 201.434 326.594 204.063 326.526 207.336L326.115 226.789C326.046 229.876 328.496 232.454 331.614 232.589L350.357 233.37C353.578 233.505 356.268 230.995 356.336 227.807L356.765 207.438C356.833 204.266 354.28 201.671 351.077 201.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M365.914 90.6002L365.486 110.952C365.417 113.971 367.867 116.464 370.917 116.481L390.225 116.583C393.206 116.583 395.656 114.242 395.724 111.291L396.17 90.1423C396.238 87.0386 393.651 84.5116 390.499 84.6133L371.174 85.2917C368.278 85.3935 365.965 87.717 365.897 90.5832L365.914 90.6002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M365.04 131.474L364.628 151.029C364.56 153.997 366.924 156.456 369.922 156.558L389.213 157.185C392.263 157.287 394.799 154.896 394.867 151.894L395.295 131.677C395.364 128.642 392.88 126.148 389.813 126.148L370.505 126.182C367.541 126.182 365.108 128.54 365.04 131.491V131.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.645 74.9632L197.536 81.408C197.828 83.4771 199.575 85.0205 201.682 85.0714H201.991C204.355 85.1223 206.308 83.2736 206.36 80.9331L206.497 74.3357C206.548 71.7747 204.321 69.7565 201.751 70.0448L200.415 70.1974C198.016 70.4518 196.32 72.6227 196.645 74.9802V74.9632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M226.884 73.3011L227.775 79.7459C228.066 81.815 229.813 83.3584 231.921 83.4093H232.229C234.593 83.4601 236.546 81.6115 236.598 79.271L236.735 72.6736C236.786 70.1126 234.559 68.0944 231.989 68.3827L230.653 68.5353C228.254 68.7897 226.558 70.9606 226.884 73.3181V73.3011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.062 73.8099L264.952 80.2547C265.244 82.3238 266.991 83.8672 269.098 83.918H269.407C271.771 83.9689 273.724 82.1203 273.776 79.7798L273.913 73.1824C273.964 70.6214 271.737 68.6032 269.167 68.8915L267.831 69.0441C265.432 69.2985 263.736 71.4694 264.062 73.8268V73.8099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M300.296 72.1986L301.187 78.6434C301.478 80.7125 303.226 82.2558 305.333 82.3067H305.641C308.005 82.3576 309.959 80.509 310.01 78.1685L310.147 71.571C310.198 69.0101 307.971 66.9918 305.401 67.2802L304.065 67.4328C301.666 67.6872 299.97 69.8581 300.296 72.2155V72.1986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M337.526 67.5177L338.417 73.9625C338.709 76.0316 340.456 77.5749 342.563 77.6258H342.872C345.236 77.6767 347.189 75.828 347.24 73.4876L347.377 66.8901C347.429 64.3292 345.202 62.3109 342.632 62.5993L341.295 62.7519C338.897 63.0063 337.201 65.1772 337.526 67.5346V67.5177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M376.946 68.3487L377.837 74.7935C378.128 76.8626 379.876 78.406 381.983 78.4569H382.292C384.656 78.5077 386.609 76.6591 386.66 74.3186L386.797 67.7212C386.849 65.1602 384.622 63.142 382.052 63.4303L380.715 63.5829C378.317 63.8373 376.621 66.0082 376.946 68.3657V68.3487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M410.218 67.6534L411.109 74.0982C411.4 76.1673 413.147 77.7107 415.255 77.7616H415.563C417.927 77.8124 419.88 75.9638 419.932 73.6233L420.069 67.0259C420.12 64.4649 417.893 62.4467 415.323 62.735L413.987 62.8876C411.588 63.142 409.892 65.3129 410.218 67.6704V67.6534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.406 0.322269C381.814 3.03587 382.996 35.8535 384.007 49.184C384.247 52.3216 386.885 54.7299 390.055 54.7299C393.224 54.7299 391.768 54.3568 392.368 53.7124C392.95 53.0679 393.241 52.186 393.139 51.321C392.042 41.2467 389.729 12.2621 399.015 10.7018C399.015 10.7018 405.662 9.53155 406.793 22.3024H413.989C413.989 22.3024 410.237 -3.08669 394.406 0.322269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.055 2.00114C320.463 4.71474 321.645 37.5493 322.656 50.8629C322.895 54.0005 325.534 56.4258 328.703 56.4258C331.873 56.4258 330.417 56.0527 331.016 55.4082C331.599 54.7637 331.89 53.8987 331.787 53.0168C330.691 42.9426 328.378 13.924 337.664 12.3807C337.664 12.3807 344.328 11.6005 345.442 24.0831L352.62 23.9643C352.62 23.9643 348.868 -1.40782 333.038 2.0181L333.055 2.00114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.703 3.69725C259.111 6.41085 260.293 39.2454 261.304 52.576C261.544 55.7136 264.182 58.1388 267.352 58.1388C270.521 58.1388 269.065 57.7657 269.665 57.1212C270.247 56.4768 270.538 55.6118 270.436 54.7299C269.339 44.6557 267.026 15.6201 276.312 14.0768C276.312 14.0768 282.959 13.3305 284.073 25.8809L291.269 25.6265C291.269 25.6265 287.517 0.271331 271.686 3.69725H271.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.369 5.6647C197.777 8.3783 198.959 41.2298 199.97 54.5604C200.21 57.698 202.848 60.1402 206.018 60.1402C209.187 60.1402 207.731 59.7671 208.331 59.1226C208.913 58.4781 209.204 57.6132 209.102 56.7482C208.005 46.674 205.692 17.6045 214.978 16.0612C214.978 16.0612 221.66 15.2301 222.773 27.7127L229.952 27.594C229.952 27.594 226.2 2.2727 210.369 5.69862V5.6647Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397.592 65.8725C397.506 64.4818 396.033 63.8882 394.954 64.7193C391.887 67.1106 390.653 70.8079 389.146 74.2677C387.381 78.2873 385.702 82.3577 384.212 86.4789C382.635 90.8377 381.299 95.2642 380.271 99.7586C378.25 94.3823 375.885 89.1417 372.887 84.1893C372.099 82.8665 369.855 83.6466 370.3 85.2069C372.887 94.3145 376.074 103.235 378.507 112.377C379.363 115.599 383.835 114.836 384.16 111.732C385.068 103.252 387.141 95.1455 390.071 87.1404C391.459 83.3413 393.018 79.5932 394.645 75.8789C396.067 72.5887 397.815 69.5189 397.609 65.8556L397.592 65.8725Z",
    fill: "url(#paint4_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.789 72.6227C399.134 72.1309 398.157 75.5059 400.607 76.5574C416.746 83.5958 418.87 103.405 407.203 115.396C401.807 120.942 394.645 125.25 387.878 128.947C381.008 132.695 373.333 135.578 365.349 134.781C346.863 132.949 344.345 114.31 349.878 99.9283C355.189 86.1059 366.582 75.4211 380.528 70.3162C382.327 69.6547 381.625 66.7546 379.791 67.416C366.702 72.063 355.583 81.2214 348.679 93.2122C342.34 104.236 338.537 119.788 346.829 130.863C355.429 142.311 371.739 142.515 384.023 137.749C397.541 132.492 414.382 122.756 419.761 108.612C425.398 93.8058 418.442 75.7094 401.807 72.6227H401.789Z",
    fill: "url(#paint5_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.8184 77.1001C63.8184 77.1001 63.8184 77.168 63.8527 77.3038C63.8527 77.2359 63.8527 77.168 63.8355 77.1001H63.8184Z",
    fill: "url(#paint6_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M109.75 119.738L110.555 119.907C110.281 119.839 110.024 119.788 109.75 119.738Z",
    fill: "url(#paint7_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M68.4277 119.958L68.6328 119.924C68.5644 119.924 68.4961 119.941 68.4277 119.958Z",
    fill: "url(#paint8_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.6013 213.594C65.6013 213.594 53.1803 210.321 51.073 183.507L50.8332 177.843L51.0902 167.701C51.0902 167.701 39.3887 162.307 37.0245 159.746C35.6025 164.088 32.7756 183.999 37.487 205.267C41.3076 207.302 45.1795 209.32 49.0857 211.288C49.394 211.44 49.6853 211.593 49.9937 211.746C55.2705 214.391 60.6672 216.969 66.2181 219.513C66.2352 216.359 65.6013 213.611 65.6013 213.611V213.594Z",
    fill: "url(#paint9_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M126.472 126.165C123.182 123.859 117.512 121.62 110.556 119.907C110.556 119.907 108.911 135.375 90.3739 135.714C72.1793 136.053 68.4273 119.975 68.4273 119.975C63.4931 121.298 58.8503 123.469 54.6357 126.318C42.7801 134.391 35.653 156.999 36.6467 159.254C36.7152 159.407 36.8351 159.577 37.0065 159.763C39.3879 162.324 51.0722 167.717 51.0722 167.717L50.8152 177.86L51.1578 184.661C53.6249 210.711 65.5833 213.611 65.5833 213.611C65.5833 213.611 66.2172 216.359 66.2001 219.513C73.7726 222.973 81.6535 226.348 89.9798 229.672C100.362 225.331 125.444 214.171 129.419 212.322L130.275 178.233L130.515 168.532C130.515 168.532 138.276 165.75 144.803 159.492C145.06 159.254 145.3 159 145.557 158.763C142.045 145.992 136.272 133.085 126.455 126.165H126.472Z",
    fill: "url(#paint10_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.838 159.492C138.328 165.733 130.55 168.531 130.55 168.531L130.31 178.232C130.241 178.114 130.019 183.117 129.779 188.086C129.488 194.26 127.226 200.196 123.32 205.029L116.398 213.594C116.398 213.594 115.833 215.494 115.799 218.428C120.87 216.206 130.43 211.881 130.43 211.881C135.295 209.609 139.27 207.98 141.84 206.708C148.984 189.63 145.661 163.325 144.838 159.509V159.492Z",
    fill: "url(#paint11_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.309 178.216C130.172 177.978 129.915 177.826 129.606 177.826H49.8892C49.4438 177.826 49.084 178.182 49.084 178.623V211.271C49.3924 211.423 49.6836 211.576 49.992 211.729C55.2688 214.374 60.6655 216.952 66.2164 219.496C73.7889 222.956 81.6698 226.331 89.9961 229.655C99.3333 226.026 108.122 221.803 115.798 218.428C120.869 216.206 130.103 212.034 130.429 211.881V178.64C130.429 178.487 130.377 178.351 130.309 178.233V178.216Z",
    fill: "url(#paint12_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.024 248.566C166.733 248.481 166.424 248.413 166.099 248.328C156.796 246.208 135.278 247.345 135.278 247.345L135.243 247.446C136.237 247.887 137.128 248.583 137.865 249.465C139.184 251.059 139.852 253.162 139.749 255.316C139.664 257.029 138.944 258.623 137.779 259.759C136.614 260.896 135.072 261.472 133.513 261.371L132.965 261.337V261.371C132.965 261.371 153.455 265.034 163.546 265.017C164.574 265.017 165.516 264.864 166.373 264.593C173.946 262.253 174.854 250.754 167.024 248.566Z",
    fill: "url(#paint13_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M137.849 249.465C137.112 248.583 136.221 247.887 135.227 247.446C134.439 247.09 133.6 246.887 132.726 246.853L131.921 246.819C130.088 251.076 129.231 255.638 129.351 260.506C129.351 260.692 129.351 260.896 129.385 261.082L132.949 261.337L133.497 261.371C135.056 261.472 136.598 260.896 137.763 259.759C138.928 258.623 139.647 257.029 139.733 255.316C139.853 253.162 139.168 251.059 137.849 249.465Z",
    fill: "url(#paint14_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.388 261.201H38.8398C37.2807 261.286 35.7559 260.658 34.6252 259.488C33.4773 258.318 32.8092 256.69 32.7749 254.977C32.7064 252.823 33.4431 250.737 34.7965 249.193C35.5504 248.328 36.4584 247.667 37.4692 247.26L34.5909 246.955C34.5909 246.955 15.9509 245.377 6.5966 247.209C6.27109 247.277 5.9627 247.345 5.67145 247.412C-2.20945 249.346 -1.59268 260.896 5.91131 263.457C6.76793 263.745 7.71021 263.932 8.73815 263.965C18.8291 264.288 39.4051 261.252 39.4051 261.252V261.218L39.388 261.201Z",
    fill: "url(#paint15_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M168.704 211.763C164.49 202.146 154.159 200.586 145.37 205.08C145.353 205.114 99.3352 226.009 89.998 229.638C92.1396 230.486 94.3154 231.351 96.5255 232.199C101.991 234.302 107.644 236.389 113.538 238.458C116.159 239.39 118.849 240.306 121.573 241.239C126.25 242.816 129.831 243.97 132.623 244.818C140.727 242.409 148.659 239.967 156.318 237.576C167.197 234.099 173.399 222.43 168.721 211.763H168.704Z",
    fill: "url(#paint16_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.7111 262.846C57.8562 262.083 73.5323 259.607 89.1228 256.215C74.6459 253.026 67.2276 250.94 60.9571 249.431C60.3575 249.278 44.8184 245.038 44.4073 244.885C43.0881 245.242 41.786 245.581 40.4668 245.903C40.5525 246.174 40.6381 246.463 40.7238 246.734C41.9573 250.957 42.6083 255.401 42.7625 259.776C42.7625 260.217 42.7625 260.641 42.7625 261.082C42.7625 261.676 42.7454 262.269 42.694 262.863L42.7111 262.846Z",
    fill: "url(#paint17_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.4166 89.3962C64.9495 83.7994 64.0073 78.3892 63.8359 77.3037C64.3156 81.4589 65.6348 85.8007 67.4166 89.3962Z",
    fill: "url(#paint18_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.833 62.4976C108.244 60.4285 110.539 54.4246 105.348 50.7782C100.825 47.6067 93.0472 51.9993 83.0076 51.6771C75.4522 51.4227 73.9788 58.6985 67.6741 63.3965C64.1619 66.0083 63.1854 71.3677 63.8193 77.1001C63.8193 77.168 63.8193 77.2358 63.8364 77.3037C64.0077 78.3891 64.95 83.7993 67.4171 89.3961C68.8905 92.7712 70.9292 96.1971 73.6704 98.792C73.5848 97.7235 73.5505 96.6381 73.5676 95.5357C73.362 95.3491 73.1564 95.0947 72.968 94.7894C71.8544 92.9408 71.2376 89.023 71.6488 85.6819C72.0942 82.1712 73.9445 82.6121 75.298 83.4771C75.8462 83.8163 76.3088 84.2403 76.5829 84.4947C76.9427 83.1888 77.3196 82.0525 77.7651 81.2723C80.1807 77.0493 86.2799 76.9814 101.802 82.2051C105.348 83.3923 108.535 83.1718 111.225 82.0694C111.55 84.376 111.327 87.4627 110.642 90.8717C113.794 87.8358 117.118 82.4256 119.602 72.7923C121.093 68.264 120.133 63.6848 115.799 62.4976H115.833Z",
    fill: "url(#paint19_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.9668 94.7895C73.1555 95.0948 73.3614 95.3491 73.5673 95.5357C73.5673 95.0439 73.5845 94.569 73.6188 94.0771C73.4129 94.3824 73.207 94.6199 72.9668 94.7895Z",
    fill: "url(#paint20_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7246 246.734L40.8447 247.142C40.8104 247.006 40.7761 246.87 40.7246 246.734Z",
    fill: "url(#paint21_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7636 259.776C42.6266 255.587 42.0269 251.33 40.8791 247.277H37.4526C36.4589 247.701 35.5337 248.345 34.7799 249.21C33.4265 250.771 32.6898 252.857 32.7583 254.994C32.8097 256.707 33.4779 258.335 34.6086 259.505C35.7565 260.675 37.2641 261.303 38.8232 261.235H39.3714C39.3714 261.218 42.7465 261.082 42.7465 261.082C42.7465 260.658 42.7465 260.217 42.7465 259.776H42.7636Z",
    fill: "url(#paint22_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8797 247.26L40.8457 247.141C40.8457 247.175 40.8627 247.226 40.8797 247.26Z",
    fill: "url(#paint23_linear_904_2490)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.241 82.0694C108.551 83.1718 105.347 83.4092 101.818 82.205C86.296 76.9644 80.1969 77.0492 77.7812 81.2722C77.3358 82.0524 76.9589 83.1887 76.5991 84.4946C76.3421 84.2402 75.8624 83.8332 75.3142 83.477C73.9607 82.6121 72.0933 82.1711 71.665 85.6818C71.2538 89.023 71.8534 92.9407 72.9842 94.7894C73.1726 95.0946 73.3782 95.349 73.5838 95.5356C73.5838 96.638 73.6009 97.7234 73.6866 98.7919C74.0806 103.676 75.6397 108.222 79.0833 111.648C80.7965 113.361 82.9723 114.802 85.6964 115.871C90.3907 117.719 94.6224 116.634 98.2202 113.92C104.593 109.104 109.031 99.0972 110.693 90.8716C111.378 87.4626 111.601 84.3759 111.275 82.0694H111.241Z",
    fill: "url(#paint24_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M109.751 119.738L98.4432 117.346L98.1863 113.937C94.5885 116.668 90.3568 117.736 85.6625 115.888C82.9384 114.819 80.7626 113.378 79.0494 111.665L78.8781 118.025L68.6157 119.941L68.4102 119.975C68.4102 119.975 72.1622 136.053 90.3568 135.714C108.894 135.375 110.539 119.907 110.539 119.907L109.734 119.738H109.751Z",
    fill: "url(#paint25_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M121.555 241.239C118.831 240.323 116.158 239.39 113.52 238.458C107.626 236.389 92.1387 230.503 89.9971 229.638C81.6708 226.314 73.7899 222.939 66.2173 219.479C60.6664 216.935 55.2697 214.358 49.993 211.712C49.6846 211.559 49.3933 211.406 49.0849 211.254C45.1616 209.286 41.3068 207.285 37.4863 205.233C36.5783 204.741 35.6531 204.249 34.7451 203.758C24.894 198.432 13.6723 201.994 10.5199 213.543C7.71021 223.855 14.3747 231.487 23.2836 235.744C36.407 242.019 38.4629 242.715 44.4249 244.852C44.8361 245.004 73.8755 253.196 89.1405 256.181C102.538 258.793 116.244 260.76 129.436 261.642C129.436 261.438 129.384 260.658 129.384 260.472C129.247 255.604 130.104 251.042 131.954 246.785C132.143 246.344 132.708 245.038 132.777 244.835C132.725 244.835 126.284 242.782 121.589 241.205L121.555 241.239Z",
    fill: "url(#paint26_linear_904_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7388 210.558C93.5425 210.558 96.626 207.506 96.626 203.741C96.626 199.975 93.5425 196.923 89.7388 196.923C85.9351 196.923 82.8516 199.975 82.8516 203.741C82.8516 207.506 85.9351 210.558 89.7388 210.558Z",
    fill: "url(#paint27_linear_904_2490)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_904_2490",
    x1: 471.021,
    y1: 294.392,
    x2: 368.35,
    y2: 190.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_904_2490",
    x1: 517.862,
    y1: 290.592,
    x2: 180.533,
    y2: 36.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_904_2490",
    x1: 152.547,
    y1: 251.076,
    x2: 477.482,
    y2: 27.4016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_904_2490",
    x1: 173.003,
    y1: 237.236,
    x2: 423.03,
    y2: 68.3352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_904_2490",
    x1: 516.337,
    y1: -108.205,
    x2: 450.959,
    y2: -9.12478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDD5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06EDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_904_2490",
    x1: 522.624,
    y1: -104.067,
    x2: 457.23,
    y2: -4.98627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDD5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06EDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_904_2490",
    x1: 62.8918,
    y1: 93.5191,
    x2: 64.1015,
    y2: 72.0218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_904_2490",
    x1: 175.967,
    y1: 1.59359,
    x2: 128.483,
    y2: 88.4476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_904_2490",
    x1: 143.908,
    y1: -16.7069,
    x2: 95.8855,
    y2: 70.3452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_904_2490",
    x1: 53.009,
    y1: 226.467,
    x2: 43.0509,
    y2: 127.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_904_2490",
    x1: 46.5835,
    y1: 214.018,
    x2: 139.265,
    y2: 120.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_904_2490",
    x1: 131.064,
    y1: 225.398,
    x2: 131.064,
    y2: 149.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_904_2490",
    x1: 53.9153,
    y1: 159.322,
    x2: 112.526,
    y2: 218.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDD5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06EDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_904_2490",
    x1: 209.084,
    y1: 259.081,
    x2: 120.465,
    y2: 253.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_904_2490",
    x1: 170.794,
    y1: 259.2,
    x2: 103.813,
    y2: 250.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_904_2490",
    x1: -30.9919,
    y1: 260.251,
    x2: 42.4019,
    y2: 251.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_904_2490",
    x1: 1.37216,
    y1: 261.32,
    x2: 171.126,
    y2: 215.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_904_2490",
    x1: 0.993762,
    y1: 268.697,
    x2: 170.405,
    y2: 220.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_904_2490",
    x1: 81.0026,
    y1: 23.0317,
    x2: 72.8668,
    y2: 55.5831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_904_2490",
    x1: 60.3585,
    y1: 121.79,
    x2: 112.423,
    y2: 39.5307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_904_2490",
    x1: 73.3271,
    y1: 94.0771,
    x2: 74.5342,
    y2: 72.6043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_904_2490",
    x1: 80.5656,
    y1: 140.31,
    x2: 35.5932,
    y2: 263.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_904_2490",
    x1: -2.55157,
    y1: 259.013,
    x2: 77.0416,
    y2: 249.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_904_2490",
    x1: 47.4569,
    y1: 229.346,
    x2: 40.2843,
    y2: 248.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_904_2490",
    x1: 23.5572,
    y1: 159.916,
    x2: 89.1042,
    y2: 93.7024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_904_2490",
    x1: 89.483,
    y1: 159.356,
    x2: 89.483,
    y2: 94.5689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_904_2490",
    x1: 169.868,
    y1: 263.219,
    x2: 1.40413,
    y2: 211.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_904_2490",
    x1: 76.9923,
    y1: 203.859,
    x2: 95.5638,
    y2: 203.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_904_2490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 496,
    height: 265,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.299dd170bc87ad5e9f8b180e37315d2e.svg";
export { ForwardRef as ReactComponent };